import React, { useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CandidateDetailsSchema } from "../../../Schemas/Interview System/interview_system";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { FcReading, FcStackOfPhotos } from "react-icons/fc";
import { CandidateDetailsInfo } from "../../../SchemaInfo/info";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const EditCandidateDetails = () => {
  let userData = useSelector((store) => store.login.user);
  const [candidateInfo, setCandidateInfo] = useState(CandidateDetailsInfo);
  const [loading, setLoading] = useState(false);
  const store = useSelector((store) => store.login.user);
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/interview/interview-candidate/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setCandidateInfo(res.data);
        } else {
          Toast("error", "Error while getting candidate details!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values, actions) => {
    values = {
      ...values,
      genratedBy: userData?.UserId,
    };

    let formData = new FormData();
    // for (let key in values) {
    //   formData.append(key, values[key]);
    // }
    for (let key in values) {
      if (key === "followUp") {
        formData.append("followUp", JSON.stringify(values.followUp));
      } else {
        formData.append(key, values[key]);
      }
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest(
      "PATCH",
      `/interview/update-interview-candidate/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "candidate details updated successfully!");
          navigate(`/view-candidate-details/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const checkTouched = (obj) => {
    if (obj.followUp === "" && obj.followUpDate === "") {
      return false;
    } else {
      return true;
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcReading className="fs-2 me-1" />
                  Edit Candidate Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          <div className="row">
            {/* <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  welcome to apply for both full-time jobs and internships
                  across departments. We appreciate your interest in working
                  with Kryzen Biotech—stay tuned, and we’ll connect soon if
                  there's a match.
                </p>
              </div>
            </div> */}
            <div className="col-md-12 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={candidateInfo}
                  validationSchema={CandidateDetailsSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Full Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="Fname"
                              type="text"
                              placeholder="Enter Name"
                            />
                            {props.touched.Fname && props.errors.Fname && (
                              <p className="text-danger">
                                {props.errors.Fname}
                              </p>
                            )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Last Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="Lname" type="text" />
                            {props.touched.Lname && props.errors.Lname && (
                              <p className="text-danger">
                                {props.errors.Lname}
                              </p>
                            )}
                          </div>
                        </div> */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Email
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="email"
                              type="text"
                              placeholder="Enter Email"
                            />
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Phone No
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="phoneNo"
                              type="text"
                              placeholder="Enter Contact No"
                            />
                            {props.touched.phoneNo && props.errors.phoneNo && (
                              <p className="text-danger">
                                {props.errors.phoneNo}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Position
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="position"
                              type="text"
                              placeholder="Enter Position"
                            />
                            {props.touched.position &&
                              props.errors.position && (
                                <p className="text-danger">
                                  {props.errors.position}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Interview Schedule Date
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="interviewScheduleDate"
                              type="date"
                            />
                            {props.touched.interviewScheduleDate &&
                              props.errors.interviewScheduleDate && (
                                <p className="text-danger">
                                  {props.errors.interviewScheduleDate}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Interview Type
                          </label>

                          <div className="w-100 col">
                            <CustomSelect name="interviewType">
                              <option value="">Select</option>
                              <option value="Walk-in">Walk-in</option>
                              <option value="Virtual">Virtual</option>
                            </CustomSelect>

                            {props.touched.interviewType &&
                              props.errors.interviewType && (
                                <p className="text-danger">
                                  {props.errors.interviewType}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Interview Schedule Link
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="Schedulelink"
                              type="text"
                              placeholder="Enter Interview Link"
                            />
                            {props.touched.Schedulelink &&
                              props.errors.Schedulelink && (
                                <p className="text-danger">
                                  {props.errors.Schedulelink}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Assigned Interviewer
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="assignedInterviewer"
                            >
                              <option value="">Select</option>
                              <option value="Sudhir Devkar">
                                Sudhir Devkar
                              </option>
                              <option value="Priya Devkar">Priya Devkar</option>
                              <option value="Saloni Kadam">Saloni Kadam</option>
                              <option value="Other">Other</option>
                            </CustomSelect>
                            {props.touched.assignedInterviewer &&
                              props.errors.assignedInterviewer && (
                                <p className="text-danger">
                                  {props.errors.assignedInterviewer}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Departments
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="departments">
                              <option value="">Select</option>
                              <option value="Business Development Department">
                                Business Development Department (Sales)
                              </option>
                              <option value="Operations Executive Department">
                                Operations Executive Department (Purchase)
                              </option>
                              <option value="Social Media Marketing Department">
                                Social Media Marketing Department (Video
                                Editing, Graphic Design)
                              </option>
                              <option value="Human Resources">
                                Human Resources Department
                              </option>
                              <option value="Accounting Department">
                                Accounting Department
                              </option>
                              <option value="Management Department">
                                Management Department
                              </option>
                              <option value="Agronomist Department">
                                Agronomist Department
                              </option>
                            </CustomSelect>
                            {props.touched.departments &&
                              props.errors.departments && (
                                <p className="text-danger">
                                  {props.errors.departments}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Upload CV
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadcv"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadcv",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.uploadcv &&
                              props.errors.uploadcv && (
                                <p className="text-danger">
                                  {props.errors.uploadcv}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3 ">
                            Job Type
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="jobType">
                              <option value="">Select</option>
                              <option value="Internship">Internship</option>
                              <option value="job">Job</option>
                            </CustomSelect>
                            {props.touched.jobType && props.errors.jobType && (
                              <p className="text-danger">
                                {props.errors.jobType}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3 ">
                            Employee Type
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="Etype">
                              <option value="">Select</option>
                              <option value="Fresher">Fresher</option>
                              <option value="Experience">Experience</option>
                            </CustomSelect>
                            {props.touched.Etype && props.errors.Etype && (
                              <p className="text-danger">
                                {props.errors.Etype}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Skills
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="skills"
                              type="text"
                              placeholder="e.g. communication, graphic design, video editing"
                            />
                            {props.touched.skills && props.errors.skills && (
                              <p className="text-danger">
                                {props.errors.skills}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Recruiter Remarks
                          </label>

                          <div className="w-100 col">
                            <CustomTextArea
                              name="recruterRemark"
                              type="textarea"
                              rows={4}
                              placeholder="Enter recruiter remarks"
                            />

                            {props.touched.recruterRemark &&
                              props.errors.recruterRemark && (
                                <p className="text-danger">
                                  {props.errors.recruterRemark}
                                </p>
                              )}
                          </div>
                        </div> */}
                        <hr />
                        <h1>Follow UP / Remarks</h1>
                        <hr />

                        <FieldArray name="followUp">
                          {({ push, remove }) => (
                            <div>
                              {props.values.followUp?.map((followup, index) => (
                                <div
                                  key={index}
                                  className="card mb-4 shadow-sm"
                                >
                                  <div className="card-body">
                                    <div className="row g-4">
                                      {/* Message */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-bold required">
                                          Message
                                        </label>

                                        <CustomTextArea
                                          rows={5}
                                          name={`followUp[${index}].followUp`}
                                        />

                                        {props?.touched?.followUp?.[index]
                                          ?.followUp &&
                                          props?.errors?.followUp?.[index]
                                            ?.followUp && (
                                            <p className="text-danger">
                                              {
                                                props?.errors?.followUp?.[index]
                                                  ?.followUp
                                              }
                                            </p>
                                          )}

                                        <p className="text-warning small">
                                          Write as much precise and accurate
                                          information as you can.
                                        </p>
                                      </div>

                                      <div className="col-md-3">
                                        <div>
                                          <label className="form-label fw-bold">
                                            Follwup date
                                          </label>
                                          <div className="w-100 col">
                                            <CustomInput
                                              type="date"
                                              name={`followUp[${index}].followUpDate`}
                                              // min={
                                              //   new Date()
                                              //     .toISOString()
                                              //     .split("T")[0]
                                              // }
                                              value={
                                                props.values.followUp[index]
                                                  .followUpDate
                                              }
                                            />
                                            {props?.touched?.followUp?.[index]
                                              ?.followUpDate &&
                                              props?.errors?.followUp?.[index]
                                                ?.followUpDate && (
                                                <p className="text-danger">
                                                  {
                                                    props?.errors?.followUp?.[
                                                      index
                                                    ]?.followUpDate
                                                  }
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <div>
                                          <label className="form-label fw-bold">
                                            Created By
                                          </label>
                                          <div className="w-100 col">
                                            <p>
                                              {props.values.followUp[index]
                                                .createdByUser?.userName ||
                                                "N/A"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}

                              {/* Add Follow Up Button */}
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  const newFollowUpInfo = {
                                    followUp: "",
                                    followUpDate: "",
                                    createdBy: store.UserId,
                                  };

                                  if (props.values.followUp.length === 0) {
                                    push(newFollowUpInfo);
                                  } else if (
                                    props.values.followUp.length > 0 &&
                                    checkTouched(
                                      props.values.followUp[
                                        props.values.followUp.length - 1
                                      ]
                                    )
                                  ) {
                                    push(newFollowUpInfo);
                                  } else {
                                    Toast(
                                      "error",
                                      "Please fill all follow up details."
                                    );
                                  }
                                }}
                              >
                                Add Follow Up
                              </button>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Edit Candidate Details" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditCandidateDetails;
